import { useLocalObservable } from 'mobx-react';
import React, { createContext, ReactNode } from 'react';
import { RxApi, SalesApi } from '../../api-client';
import useStore from '../../helpers/useStore';
import { AuthContext } from '../Auth/auth.provider';
import { PatientsContext } from '../Patients/patients.provider';
import { createApiConfig } from '../../api/createApiConfig';
import SalesStore from './SaleStore';


interface SalesProviderProps {
  children: ReactNode;
}

export const SalesStoreContext = createContext<SalesStore | null>(null);
SalesStoreContext.displayName = 'SalesStoreContext';

export const SalesStoreProvider = ({ children }: SalesProviderProps) => {
const AuthenticationStore = useStore(AuthContext);
const patientStore=useStore(PatientsContext)
  const apiClient = new SalesApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(
    () => new SalesStore(apiClient,AuthenticationStore)
  );

  store.apiClient = apiClient;

  return (
    <SalesStoreContext.Provider value={store}>
      {children}
    </SalesStoreContext.Provider>
  );
};